'use strict';

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

var irregularPlurals = require('./irregular-plurals.json');

var map = new Map(); // TODO: Use Object.entries when targeting Node.js 8

for (var _i = 0, _Object$keys = Object.keys(irregularPlurals); _i < _Object$keys.length; _i++) {
  var key = _Object$keys[_i];
  map.set(key, irregularPlurals[key]);
} // Ensure nobody can modify each others Map


Object.defineProperty(module, 'exports', {
  get: function get() {
    return map;
  }
});